import * as React from 'react';

const TrendingChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M116.509 38.4h12v42h-12V58.372l-43.803 43.803-8.485-8.485.048-.049-14.205-14.205-26.098 26.098-8.485-8.485 34.65-34.65 8.486 8.485-.068.067 14.206 14.205 34.757-34.758H86.508v-12h30.001z"
            fill="#4B4D63"
        />
    </svg>
);

TrendingChunkySvg.displayName = 'TrendingChunkySvg';
export default TrendingChunkySvg;
